// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Sale from "../Sale/Sale.res.js";
import * as Badge from "../../resources/feedback-indicators/Badge.res.js";
import * as Group from "../../resources/layout-and-structure/Group.res.js";
import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as Title from "../../resources/typography/Title.res.js";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as CanarySurface from "../../resources/layout-and-structure/CanarySurface.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as CanarySeparator from "../../resources/layout-and-structure/CanarySeparator.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as InputToggleSwitchField from "../../resources/selection-and-input/InputToggleSwitchField.res.js";

function trimOptionalString(value) {
  return Stdlib_Option.filter(Stdlib_Option.map(value, prim => prim.trim()), value => value !== "");
}

function formatPostalCityLine(postalCode, city) {
  let match = trimOptionalString(postalCode);
  let match$1 = trimOptionalString(city);
  if (match !== undefined) {
    if (match$1 !== undefined) {
      return match + `, ` + match$1;
    } else {
      return match;
    }
  } else if (match$1 !== undefined) {
    return match$1;
  } else {
    return;
  }
}

function infoElement(value) {
  return Stdlib_Option.mapOr(trimOptionalString(value), null, value => JsxRuntime.jsx(TextStyle.make, {
    children: value,
    size: "xsmall"
  }));
}

function CustomerLocationTile$LocationDefaultBadges(props) {
  let isDelivery = props.isDelivery;
  let isBilling = props.isBilling;
  let badgeElement = value => {
    let styleSet = Sale.BusinessSecondaryStatus.Badge.toStyleSet(value);
    let label;
    switch (value) {
      case "Delivered" :
        label = I18n.t("Delivery");
        break;
      case "Refunded" :
        label = "";
        break;
      case "Billed" :
        label = I18n.t("Billing");
        break;
    }
    return JsxRuntime.jsx(Badge.make, {
      children: label,
      size: "small",
      borderColor: styleSet.borderColor,
      backgroundColor: styleSet.bgColor,
      foregroundColor: styleSet.textColor
    });
  };
  if (!isBilling && !isDelivery) {
    return null;
  }
  return JsxRuntime.jsxs(Inline.make, {
    children: [
      isBilling ? badgeElement("Billed") : null,
      isDelivery ? badgeElement("Delivered") : null
    ],
    space: "xsmall",
    grow: false,
    wrap: true
  });
}

let LocationDefaultBadges = {
  make: CustomerLocationTile$LocationDefaultBadges
};

function CustomerLocationTile$LocationDefaultToggleRow(props) {
  let active = props.active;
  return JsxRuntime.jsx(InputToggleSwitchField.make, {
    label: props.label,
    required: false,
    value: active,
    size: "tiny",
    labelSize: "xsmall",
    labelWeight: active ? "semibold" : "regular",
    labelMaxLines: 1,
    labelSpaceRight: "small",
    onChange: props.onToggle
  });
}

let LocationDefaultToggleRow = {
  make: CustomerLocationTile$LocationDefaultToggleRow
};

function CustomerLocationTile(props) {
  let onToggleDelivery = props.onToggleDelivery;
  let onToggleBilling = props.onToggleBilling;
  let endActionsElement = props.endActionsElement;
  let isDelivery = props.isDelivery;
  let isBilling = props.isBilling;
  let label = props.label;
  let hasActions = Stdlib_Option.isSome(endActionsElement);
  let interactive = Stdlib_Option.isSome(onToggleBilling) || Stdlib_Option.isSome(onToggleDelivery);
  let grid = interactive ? (
      hasActions ? [
          "45%",
          "25%",
          "0%"
        ] : [
          "65%",
          "35%"
        ]
    ) : (
      hasActions ? [
          "85%",
          "1fr"
        ] : ["100%"]
    );
  let spaceX = "large";
  return JsxRuntime.jsx(CanarySurface.make, {
    tone: "neutral-ghost",
    grow: hasActions,
    children: JsxRuntime.jsx(Box.make, {
      children: JsxRuntime.jsxs(Group.make, {
        children: [
          JsxRuntime.jsxs(Stack.make, {
            children: [
              interactive ? JsxRuntime.jsx(Title.make, {
                  children: label,
                  level: 4,
                  weight: "bold"
                }) : JsxRuntime.jsxs(Inline.make, {
                  children: [
                    JsxRuntime.jsx(Title.make, {
                      children: label,
                      level: 4,
                      weight: "bold"
                    }),
                    JsxRuntime.jsx(CustomerLocationTile$LocationDefaultBadges, {
                      isBilling: isBilling,
                      isDelivery: isDelivery
                    })
                  ],
                  space: "small",
                  alignY: "center",
                  fullWidth: true,
                  wrap: true
                }),
              JsxRuntime.jsx(Box.make, {
                spaceTop: "xxsmall",
                spaceBottom: "xsmall"
              }),
              infoElement(props.recipient),
              infoElement(props.street),
              infoElement(formatPostalCityLine(props.postalCode, props.city)),
              infoElement(props.country)
            ],
            space: "none"
          }),
          interactive ? JsxRuntime.jsx(Inline.make, {
              children: JsxRuntime.jsxs(Stack.make, {
                children: [
                  JsxRuntime.jsx(CustomerLocationTile$LocationDefaultToggleRow, {
                    label: I18n.t("Billing"),
                    active: isBilling,
                    onToggle: Stdlib_Option.getOr(onToggleBilling, param => {})
                  }),
                  JsxRuntime.jsx(CanarySeparator.make, {
                    orientation: "horizontal",
                    spacing: "tiny"
                  }),
                  JsxRuntime.jsx(CustomerLocationTile$LocationDefaultToggleRow, {
                    label: I18n.t("Delivery"),
                    active: isDelivery,
                    onToggle: Stdlib_Option.getOr(onToggleDelivery, param => {})
                  })
                ],
                space: "xsmall"
              }),
              alignY: "center",
              grow: true,
              fullWidth: true
            }) : null,
          Stdlib_Option.getOr(endActionsElement, null)
        ],
        grid: grid,
        wrap: false,
        grow: true,
        stretch: true,
        spaceX: spaceX,
        alignY: "none"
      }),
      spaceX: "medium",
      spaceY: "medium",
      grow: true
    })
  });
}

let make = CustomerLocationTile;

export {
  trimOptionalString,
  formatPostalCityLine,
  infoElement,
  LocationDefaultBadges,
  LocationDefaultToggleRow,
  make,
}
/* Box Not a pure module */
